import { render, staticRenderFns } from "./ContratoTipoVeiculoCard.vue?vue&type=template&id=5e829a26&"
import script from "./ContratoTipoVeiculoCard.vue?vue&type=script&lang=js&"
export * from "./ContratoTipoVeiculoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports